import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useDispatch, useSelector } from "react-redux";
import { Tabs } from 'antd';
import { employeesVerificationUpdate } from "../../../core/data/redux/employeesVerificationSlice";
import ShiftVerificationTable from "./shiftVerificationTable";


interface ShiftVerificationListProps {
}

const ShiftVerificationList = (props: ShiftVerificationListProps) => {
  const routes = all_routes;
  const [type, setType] = useState('PENDING');
  const onChange = (key: string) => {
    setType(key)
  };
  const tabs: any[] = ['PENDING', 'VERIFIED', 'REJECTED'];





  return (
    <div>
      <>
        <div className="page-wrapper">
          <div className="content">
            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
              <div className="my-auto mb-2">
                <h3 className="page-title mb-1">Shift Verifications</h3>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="#">Shift Verifications</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Shift Verifications
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <Tabs
              onChange={onChange}
              type="card"
              items={tabs.map((item) => {
                return {
                  label: `${item}`,
                  key: item,
                  children: <ShiftVerificationTable type={type}  />,
                };
              })}
            />
          </div>
        </div>
      </>
      
    </div>
  );
}

export default ShiftVerificationList; 